/**
 * @author gyb(mocheer)
 * @email `mocheer@foxmail.com`  
 * @since 2017.10.22
 */
let { Circle, CircleMarker } = L;
/**
 * 台风四象限风圈
 */
export default Circle.extend({
  /**
   * 初始化
   */
  initialize(latlng, options) {
    CircleMarker.prototype.initialize.call(this, latlng, options)
    this._mRadius = this.options.radius;
  },
  /**
   * 
   */
  _project() {
    let { _latlng, _map: map, options, _mRadius } = this;
    // let crs = L.CRS.EPSG3857;//map.options.crs;
    let [ne, nw, se, sw] = _mRadius;//东北，西北，东南，西南 四象限的半径，单位米
    let crs = map.options.crs;
    let { Earth } = L.CRS;
    let { lat, lng } = _latlng;
    if (crs.distance === Earth.distance) {
      let point;
      function getR(r) {
        let d = Math.PI / 180;
        let latR = (r / Earth.R) / d;
        let top = map.project([lat + latR, lng]);
        let bottom = map.project([lat - latR, lng]);
        let p = top.add(bottom).divideBy(2);
        // let lat2 = map.unproject(p).lat;
        // let lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) /
        //   (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;

        // if (isNaN(lngR) || lngR === 0) {
        //   lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
        // }
        point = point || p.subtract(map.getPixelOrigin());
        // this._radius = isNaN(lngR) ? 0 : p.x - map.project([lat2, lng - lngR]).x;
        // this._radiusY = p.y - top.y;
        // return isNaN(lngR) ? 0 : p.x - map.project([lat2, lng - lngR]).x;
        return p.y - top.y;
      }
      ne = getR(ne);
      nw = getR(nw);
      se = getR(se);
      sw = getR(sw);
      this._point = point;
      //
      this._radius = [
        sw,//西南
        se,//东南
        nw,//西北
        ne //东北
      ];
    } else {
      let xy = crs.project(_latlng);
      ne = [crs.unproject(xy.add([ne, 0])), crs.unproject(xy.add([0, -ne]))]
      nw = [crs.unproject(xy.add([-nw, 0])), crs.unproject(xy.add([0, -nw]))]
      se = [crs.unproject(xy.add([se, 0])), crs.unproject(xy.add([0, se]))]
      sw = [crs.unproject(xy.add([-sw, 0])), crs.unproject(xy.add([0, sw]))]
      //中心点
      let point = this._point = map.latLngToLayerPoint(_latlng);
      let { x } = point;
      //各象限半径 - 顺时针
      this._radius = [
        x - map.latLngToLayerPoint(sw[0]).x,//西南
        map.latLngToLayerPoint(se[0]).x - x,//东南
        x - map.latLngToLayerPoint(nw[0]).x,//西北
        map.latLngToLayerPoint(ne[0]).x - x //东北
      ]
    }
    this._updateBounds();
  },
  /**
   * 绘制风圈
   */
  _updatePath() {
    this._renderer._updateCircular(this);
  },
  /**
   * 修改边界
   */
  _updateBounds() {
    let { _point, _radius } = this;
    let w = this._clickTolerance();
    let [ne, nw, se, sw] = _radius;
    let maxR = Math.max(ne, nw, se, sw);
    let p = [maxR + w, maxR + w];
    this._pxBounds = new L.Bounds(_point.subtract(p), _point.add(p));
  }
})


// WEBPACK FOOTER //
// ./src/feature/Quadrant.js